import { z } from "zod";

export const TeamAccess = z.enum(["all", "selected"]);
export const Team = z.object({
  id: z.string(), orgId: z.string(), name: z.string(), access: TeamAccess,
  memberIds: z.array(z.string()), repoIds: z.array(z.string()), createdAt: z.number(),
});
export type Team = z.infer<typeof Team>;
export const SaveTeamRequest = z.object({
  name: z.string().trim().min(1).max(80),
  access: TeamAccess,
  memberIds: z.array(z.string().min(1).max(100)).max(1000),
  repoIds: z.array(z.string().min(1).max(100)).max(1000),
}).refine((team) => team.access !== "all" || team.repoIds.length === 0, {
  message: "Everything access cannot include individual repositories", path: ["repoIds"],
});
export type SaveTeamRequest = z.infer<typeof SaveTeamRequest>;
export const TeamsResponse = z.object({ teams: z.array(Team) });
export type TeamsResponse = z.infer<typeof TeamsResponse>;
export const TeamResponse = z.object({ team: Team });
export type TeamResponse = z.infer<typeof TeamResponse>;
